import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'

export default class NotesGroup extends React.Component {

  static propTypes = {
    mode: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    list: PropTypes.array.isRequired
  }
  
  formatDate = value => {
    return moment(value).format('ddd, MMM DD, YYYY')
  }

  getGroupHeader = () => {
    if (this.props.mode === 'date') {
      return this.formatDate(this.props.header)
    }
    return this.props.header
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.groupHeader}>
          {this.getGroupHeader()}
        </div>
        <ul style={styles.photos}>
          { this.props.list && this.props.list
            .map((note, index) =>
              <li key={index}>
                <span style={{ marginRight: 4 }}>
                  { note.value }
                </span>
                -
                <span style={{ color: '#000', marginLeft: 4 }}>
                  { this.props.mode === 'date' ? note.memberName : this.formatDate(note.dateStr) }
                </span>
              </li>)
          }
        </ul>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: 12
  },
  groupHeader: {
    color: '#000'
  }
}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/notes/NotesGroup.js